// extracted by mini-css-extract-plugin
export default {"detailsContainer":"styles_detailsContainer__9wni0","headerText":"styles_headerText__cFHKC","detailsPanes":"styles_detailsPanes__mOeLK"};